import React from 'react';
import { cn } from '../lib/utils';

const orientations = [
  { id: 'all', label: 'All', color: 'from-purple-500 to-violet-600' },
  { id: 'straight', label: 'Straight', color: 'from-pink-500 to-rose-600' },
  { id: 'gay', label: 'Gay', color: 'from-blue-500 to-indigo-600' },
  { id: 'trans', label: 'Trans', color: 'from-cyan-400 to-teal-500' },
];

const OrientationTabs = ({ selected, onChange, className }) => {
  return (
    <div className={cn("flex flex-wrap gap-2", className)} data-testid="orientation-tabs">
      {orientations.map(({ id, label, color }) => (
        <button
          key={id}
          onClick={() => onChange(id)}
          className={cn(
            "px-4 py-2 md:px-6 md:py-2.5 rounded-sm font-medium text-xs md:text-sm uppercase tracking-wider transition-all duration-300 whitespace-nowrap",
            selected === id
              ? `bg-gradient-to-r ${color} text-white shadow-lg`
              : "bg-[#1A1A1A] text-gray-400 hover:text-white hover:bg-[#252525] border border-white/10"
          )}
          data-testid={`orientation-${id}`}
        >
          {label}
        </button>
      ))}
    </div>
  );
};

export const OrientationBanner = ({ orientation }) => {
  const config = {
    all: { 
      gradient: 'from-purple-500/20 to-violet-600/20', 
      border: 'border-purple-500/30',
      text: 'text-purple-400',
      label: 'All'
    },
    straight: { 
      gradient: 'from-pink-500/20 to-rose-600/20', 
      border: 'border-pink-500/30',
      text: 'text-pink-400',
      label: 'Straight'
    },
    gay: { 
      gradient: 'from-blue-500/20 to-indigo-600/20', 
      border: 'border-blue-500/30',
      text: 'text-blue-400',
      label: 'Gay'
    },
    trans: { 
      gradient: 'from-cyan-400/20 to-teal-500/20', 
      border: 'border-cyan-500/30',
      text: 'text-cyan-400',
      label: 'Trans'
    },
  };

  const { gradient, border, text, label } = config[orientation] || config.all;

  return (
    <div className={cn(
      "inline-flex items-center gap-2 px-3 py-1 rounded-full bg-gradient-to-r border",
      gradient, border
    )}>
      <span className={cn("text-xs font-medium uppercase tracking-wider", text)}>
        {label}
      </span>
    </div>
  );
};

export default OrientationTabs;
